import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import {
  paymentMessagesAtom,
  paymentSummaryAtom,
} from "checkout-experience/atoms/payment-atoms";
import { usePaymentOptionContext } from "checkout-experience/components/payment-method/payment-option-provider";
import { useSurcharge } from "checkout-experience/hooks/use-surcharge";
import { createSelectedPaymentDisplay } from "checkout-experience/utils/payment-helpers";
import { ChexFieldValues } from "checkout-query-client/types/chex-form-fields";

import { useEnabledSavedPaymentMethods } from "./use-enabled-saved-payment-methods";

export const useGeneratePaymentSummary = () => {
  const setPaymentSummary = useSetAtom(paymentSummaryAtom);
  const paymentMessages = useAtomValue(paymentMessagesAtom);
  const { paymentOption } = usePaymentOptionContext() ?? {};
  const { watch } = useFormContext();
  const enabledSavedMOPs = useEnabledSavedPaymentMethods();
  const surcharge = useSurcharge();

  useEffect(() => {
    // Set on load
    const formFields = watch(`${paymentOption?.formId}`) as ChexFieldValues;
    const summary = paymentOption?.formId
      ? {
          ...createSelectedPaymentDisplay(
            paymentOption,
            formFields,
            enabledSavedMOPs,
            paymentMessages
          ),
          surcharge,
        }
      : undefined;
    setPaymentSummary(summary);
  }, [
    watch,
    paymentOption?.formId,
    JSON.stringify(enabledSavedMOPs),
    paymentMessages,
    JSON.stringify(surcharge),
  ]);

  useEffect(() => {
    // Subscribe to form updates
    const subscription = watch((values) => {
      const fieldValues = values[`${paymentOption?.formId}`] as ChexFieldValues;
      const summary = paymentOption?.formId
        ? {
            ...createSelectedPaymentDisplay(
              paymentOption,
              fieldValues,
              enabledSavedMOPs,
              paymentMessages
            ),
            surcharge,
          }
        : undefined;
      setPaymentSummary(summary);
    });
    return () => subscription.unsubscribe();
  }, [
    watch,
    paymentOption?.formId,
    JSON.stringify(enabledSavedMOPs),
    paymentMessages,
    JSON.stringify(surcharge),
  ]);
};
